import { render } from "./UserLayoutPage.vue?vue&type=template&id=8300b932&ts=true"
import script from "./UserLayoutPage.vue?vue&type=script&lang=ts"
export * from "./UserLayoutPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__